<template>
  <div class="feedback-file-upload">
    <div class="uploaded-files">
      <span v-if="uploadedItems.length === 0" class="uploaded-nofiles">No files uploaded</span>
      <div v-for="(file, idx) in uploadedItems" :key="idx" class="evidence-item">
        <b-dropdown
          size="xs"
          variant="outline-dark"
          class="mx-1 evidence-dropdown"
          right
          :text="file.name"
          :title="file.name"
        >
          <b-dropdown-item @click="removeFile(file)" class="dropdown-danger">Delete</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-row v-if="uploading" class="mt-3">
      <b-col sm="12">
        <b-progress
          :value="uploadPercentage"
          :max="100"
          variant="info"
          show-progress
          animated
        />
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col sm="12">
        <b-form-file
          @input="uploadFile"
          ref="fileInput"
          v-model="selectedFile"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "FeedbackFileUpload",
  props: {
    requestId: { type: String, required: true },
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedFile: null,
      uploadedItems: [],
      uploading: false,
      uploadPercentage: 0,
    };
  },
  methods: {
    removeFile(file) {
      this.uploadedItems = this.uploadedItems.filter((v) => v.id !== file.id);
      this.emitValue();
    },
    emitValue() {
      this.$emit("input", this.uploadedItems.map((v) => ({ id: v.id, name: v.name })));
    },
    uploadFile() {
      if (!this.selectedFile) return;

      if (this.selectedFile.size > 10 * 1024 * 1024) {
        this.$error("File Size", "The file cannot exceed 10MB");
        return;
      }

      this.uploading = true;
      this.uploadPercentage = 0;

      const fileName = this.selectedFile.name;
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const contentType = this.selectedFile.type;
        const url = `entries/feedback/upload?filename=${encodeURIComponent(fileName)}&request_id=${encodeURIComponent(this.requestId)}`;

        this.$api.v2
          .post(url, data, {
            progress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                this.uploadPercentage = (progressEvent.loaded / progressEvent.total) * 100;
              }
            },
            headers: {
              "Content-Type": contentType,
            },
          })
          .then((resp) => {
            this.uploadedItems.push({
              id: resp.body.storageId,
              name: fileName,
            });
            this.emitValue();
            this.$refs.fileInput.reset();
          })
          .catch((resp) => {
            this.$httpError("Failed to upload file", resp);
          })
          .finally(() => {
            this.uploading = false;
          });
      };

      reader.readAsArrayBuffer(this.selectedFile);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.uploadedItems = (val || []).map((item) => ({ id: item.id, name: item.name }));
      },
    },
  },
};
</script>

<style scoped lang="scss">
.uploaded-files {
  border: 1px dashed #bbb;
  padding: 24px 12px;
  margin: auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
}

.uploaded-nofiles {
  font-weight: 600;
}
</style>
